import {Store} from "./store";

const TrackCookieMap = {
    _ym_uid: 'yid', // Yandex
    _ga: 'gid', // Google
}

interface CookieState extends Object {
    cookies: [], // [cookieKey => cookieValue]
}

export class CookieStore extends Store<CookieState>
{
    protected getInitData(): CookieState {
        return {
            cookies: this.parseCookie(document.cookie)
        };
    }

    public addSearchTagsToUrl(link: URL): URL {
        const cookies = this.getState().cookies;

        for (const cookieKey in TrackCookieMap) {
            if (!cookies[cookieKey]) {
                continue;
            }
            link.searchParams.set(TrackCookieMap[cookieKey], cookies[cookieKey]);
        }
        return link;
    }

    protected setup(data: CookieState): void {
        super.setup(data);
    }

    protected parseCookie (str) {
        return str
            .split(';')
            .map(v => v.split('='))
            .reduce((acc, v) => {
                if (Array.isArray(v) && v.length === 2) {
                    acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
                }
                return acc;
            }, {});
    }
}

export const cookieStore: CookieStore = new CookieStore()